<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <ValidationObserver v-slot="{ failed, passed }">
          <form>
            <md-card class="p-25">
              <div>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>اسم مكان العمل</label>
                        <md-input v-model="schema.name"></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>إحداثي خط العرض</label>
                        <md-input
                          type="number"
                          v-model="schema.latitude"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>إحداثي خط الطول</label>
                        <md-input
                          type="number"
                          v-model="schema.longitude"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>مدى نطاق الاحداثيات ( متر )</label>
                        <md-input
                          type="number"
                          v-model="schema.radiusInMeters"
                        ></md-input>
                      </md-field>
                    </div>
                    <div
                      class="md-layout-item md-size-25 md-small-size-100 mt-25"
                    >
                      <md-field>
                        <button
                          @click="schema.departmentClassificationsId = null"
                          type="button"
                          class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                          tabindex="-1"
                        >
                          <div class="md-ripple">
                            <div class="md-button-content">
                              <i
                                class="md-icon md-icon-font md-icon-image md-theme-default"
                                ><svg
                                  height="24"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                  ></path>
                                  <path
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  ></path></svg
                              ></i>
                            </div>
                          </div>
                        </button>
                        <label>التصنيف</label>
                        <md-select v-model="schema.departmentClassificationsId">
                          <md-option
                            v-for="classification in classifications"
                            v-bind:key="classification.id"
                            :value="classification.id"
                            >{{ classification.name }}</md-option
                          >
                        </md-select>
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout">
                    <div
                      class="md-layout-item md-size-100 center-content mt-25"
                    >
                      <md-button
                        @click="searchData"
                        class="md-info btn_nanosoft"
                      >
                        بحث
                      </md-button>
                      <md-button @click="save" class="md-success btn_nanosoft">
                        حفظ
                      </md-button>
                      <md-button @click="clear" class="md-info btn_nanosoft">
                        جديد
                      </md-button>
                    </div>
                  </div>
                </md-card-content>
              </div>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <md-progress-bar
            v-if="isLoading"
            md-mode="indeterminate"
          ></md-progress-bar>
          <md-table
            :value="allData"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="الاسم">{{ item.name }}</md-table-cell>

              <md-table-cell md-label="إحداثي خط العرض">{{
                item.latitude
              }}</md-table-cell>

              <md-table-cell md-label="إحداثي خط الطول">{{
                item.longitude
              }}</md-table-cell>

              <md-table-cell md-label="مدى نطاق الاحداثيات">{{
                item.radiusInMeters
              }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                  :disabled="isLoading"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { extractErrorMessage } from "@/services/error.js";

export default {
  name: "WorkPlaces",
  data() {
    return {
      allData: [],
      classifications: [],
      currentId: "",
      schema: {
        name: "",
        latitude: "",
        longitude: "",
        radiusInMeters: "",
        departmentClassificationsId: null,
      },
      isLoading: false,
    };
  },
  mounted() {
    this.fetchData();
    this.loadClassifications();
  },
  methods: {
    showMessage(type, message) {
      this.$notify({
        timeout: 3000,
        message: message,
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
      });
    },
    async save() {
      try {
        this.isLoading = true;
        if (this.currentId) {
          await this.update();
          return;
        }
        this.schema.departmentClassificationsId =
          this.schema.departmentClassificationsId || null;
        const { data } = await this.$axios.post("/api/workPlaces", this.schema);
        this.fetchData();
        this.showMessage("success", data.message);
        this.clear();
      } catch (error) {
        this.showMessage("danger", extractErrorMessage(error));
      } finally {
        this.isLoading = false;
      }
    },
    clear() {
      this.schema.name = "";
      this.schema.latitude = "";
      this.schema.longitude = "";
      this.schema.radiusInMeters = "";
      this.schema.departmentClassificationsId = null;
      this.currentId = "";
    },
    async fetchData() {
      this.isLoading = true;
      const { data } = await this.$axios.get("/api/workPlaces");
      this.allData = data.data;
      this.isLoading = false;
    },

    async update() {
      try {
        this.isLoading = true;
        const { data } = await this.$axios.put(
          `/api/workPlaces/${this.currentId}`,
          this.schema
        );
        this.fetchData();
        this.showMessage("success", data.message);
        this.clear();
      } catch (error) {
        this.showMessage("danger", extractErrorMessage(error));
      } finally {
        this.isLoading = false;
      }
    },

    async handleEdit(item) {
      this.currentId = item.id;
      this.schema.name = item.name;
      this.schema.latitude = item.latitude;
      this.schema.longitude = item.longitude;
      this.schema.radiusInMeters = item.radiusInMeters;
      this.schema.departmentClassificationsId =
        item.departmentClassificationsId || null;
    },
    async loadClassifications() {
      try {
        const { data } = await this.$axios.get(
          "/api/departmentClassifications"
        );
        this.classifications = data.data;
      } catch (error) {}
    },
    async searchData() {
      this.isLoading = true;
      try {
        const params = {
          name: this.schema.name || "",
          departmentClassificationsId:
            this.schema.departmentClassificationsId || ""
        };
        const { data } = await this.$axios.get("/api/workPlaces", { params });
        this.allData = data.data;
      } catch (error) {
        this.showMessage("danger", extractErrorMessage(error));
      } finally {
        this.isLoading = false;
      }
    },
    async handleDelete(item) {
      this.isLoading = true;
      try {
        const { data } = await this.$axios.delete(`/api/workPlaces/${item.id}`);
        this.fetchData();
        this.showMessage("success", "تم الحذف بنجاح");
      } catch (error) {
        this.showMessage("danger", extractErrorMessage(error));
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
